/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationStepsControllerCreateMutationRequest, WorkflowApplicationStepsControllerCreateMutationResponse, WorkflowApplicationStepsControllerCreate400, WorkflowApplicationStepsControllerCreate401, WorkflowApplicationStepsControllerCreate403 } from "../../models/workflowsController/WorkflowApplicationStepsControllerCreate";

function getWorkflowApplicationStepsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/workflow-application-steps` as const }  
  return res
}

/**
 * @summary Insert a pending step into a workflow application
 * {@link /api/v1/workflow-application-steps}
 */
export async function workflowApplicationStepsControllerCreate(data?: WorkflowApplicationStepsControllerCreateMutationRequest, config: Partial<RequestConfig<WorkflowApplicationStepsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowApplicationStepsControllerCreateMutationResponse, ResponseErrorConfig<WorkflowApplicationStepsControllerCreate400 | WorkflowApplicationStepsControllerCreate401 | WorkflowApplicationStepsControllerCreate403>, WorkflowApplicationStepsControllerCreateMutationRequest>({ method : "POST", url : getWorkflowApplicationStepsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}